import { logWarning } from '@core/logging'

import type { ParamsConfig, ParamsType } from './types'

function isFalsyStringValue(value: string | null) {
  if ((value && value === 'false') || (value && value === '0')) {
    return true
  }
  return false
}

/**
 * Parses the raw attributes into params.
 *
 * @param attributes Raw attributes as string key/value pairs.
 * @param config The params config indicating which params are strings,
 *     booleans, and numbers.
 * @returns The parsed params.
 */
export function parseParams<Config extends ParamsConfig>(
  attributes: Record<string, string>,
  config: Config,
): ParamsType<typeof config> {
  return Object.entries(attributes).reduce((acc, [key, value]) => {
    if (config.stringParams.includes(key)) {
      acc[key] = value
    } else if (config.boolParams.includes(key)) {
      acc[key] = !isFalsyStringValue(value)
    } else if (config.numberParams.includes(key)) {
      acc[key] = Number(value) || 0
    } else if (value && config.enumParams[key]) {
      if (config.enumParams[key].includes(value)) {
        acc[key] = value
      } else {
        logWarning(`Invalid enum param value: ${key}=${value}`)
      }
    }
    return acc
  }, {})
}
